/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CompanyLayoutStatusType = "ACTIVE" | "DRAFT" | "%future added value";
export type CompanyLayoutQueryVariables = {|
  companyId: string,
  companyLayoutId: string,
|};
export type CompanyLayoutQueryResponse = {|
  +Me: ?{|
    +Company: ?{|
      +businessPost: ?{|
        +companyLayout: ?{|
          +id: string,
          +tableId: number,
          +name: string,
          +layout: string,
          +status: CompanyLayoutStatusType,
        |}
      |}
    |}
  |}
|};
export type CompanyLayoutQuery = {|
  variables: CompanyLayoutQueryVariables,
  response: CompanyLayoutQueryResponse,
|};
*/


/*
query CompanyLayoutQuery(
  $companyId: ID!
  $companyLayoutId: ID!
) {
  Me {
    Company(id: $companyId) {
      businessPost {
        companyLayout(id: $companyLayoutId) {
          id
          tableId
          name
          layout
          status
        }
      }
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyLayoutId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "companyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "BusinessPost",
  "kind": "LinkedField",
  "name": "businessPost",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "companyLayoutId"
        }
      ],
      "concreteType": "CompanyLayout",
      "kind": "LinkedField",
      "name": "companyLayout",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tableId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "layout",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanyLayoutQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompanyLayoutQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "374fee951ce36b4bdeab0699c5098a35",
    "id": null,
    "metadata": {},
    "name": "CompanyLayoutQuery",
    "operationKind": "query",
    "text": "query CompanyLayoutQuery(\n  $companyId: ID!\n  $companyLayoutId: ID!\n) {\n  Me {\n    Company(id: $companyId) {\n      businessPost {\n        companyLayout(id: $companyLayoutId) {\n          id\n          tableId\n          name\n          layout\n          status\n        }\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e4e5c7fe38c67718a8f55c034098c3ca';

module.exports = node;
